import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

import { requestKey } from '../api/api';
import { apiList, getCancelData } from '../api/callAPI';

import FormTitle from '../components/setSendData/FormTitle';
import NameAndAccountData from '../components/setSendData/NameAndAccountData';
import CreateFields from '../components/setSendData/CreateFields';
import EmailTemplate from '../components/setSendData/EmailTemplate';
import DownloadReportModal from '../components/setSendData/DownloadReportModal';
import SendTime from '../components/setSendData/SendTime';
import EmailData from '../components/setSendData/EmailData';
import ButtonReportData from '../components/setSendData/ButtonReportData';
import ButtonSendData from '../components/setSendData/ButtonSendData';
import NoAdAccountPage from '../components/setSendData/NoAdAccountPage';
import { SEND_TIME_DATA, handleBiweeklyStart } from '../components/setSendData/data/emailConstants';

import ExcelData from '../components/setSendData/ExcelData';
import TaboolaCampaignData from '../components/setSendData/taboola/TaboolaCampaignData';
import TaboolaFieldsData from '../components/setSendData/taboola/TaboolaFieldsData';

import ModalComponent from '../components/modal/ModalComponent';
import Loading from '../components/loading/Loading';
import AlertMsg from '../components/alert/AlertMsg';
import { BoxModalAlert } from '../components/customComponent';
import { MODAL_CREATE_REPORT } from '../components/modal/constants';
import {
  INPUT_ERROR_MSG,
  DOWNLOAD_ERROR_MSG,
  checkDateRangeForm,
  checkExcelNaming,
  checkReportForm
} from '../components/formData/formData';

import * as basicConstants from '../constants/basic';
import * as urlConstants from '../constants/url';
import * as alertConstants from '../constants/alertMsg';

import useUser from '../hook/useUser';
import useGlobalStatus from '../hook/useGlobalStatus';
import useApiError from '../hook/useApiError';
import useCancel from '../hook/useCancel';
import useColorSystem from '../hook/useColorSystem';
import useReportData from '../hook/useReportData';
import useReportStatus from '../hook/useReportStatus';
import useModifyReport from '../hook/useModifyReport';

import { excelSheets } from '../utils/TaboolaFieldsDefined';
import { formatDate, formatDate2, formatDate3, handleDateRange } from '../utils/date';
import { handleRelatedFields } from '../utils/fieldsUtils';
import { scrollToAnchor } from '../utils/commonUtils';

const media = "TABOOLA";
const mediaDisplayName = "Taboola";

const TaboolaCreateData = (props) => {
  const history = useHistory();
  const { handleApiErrorStatus } = useApiError();
  const { userData, setUserData, setAuthStatusMsg } = useUser();
  const { currentActiveData, setCurrentActiveData, locale, setLocale, entryPath, setEntryPath, setModalContent, setModalData, modalName, setModalName, setIsModalOpen, handleAlertMsgSettings } = useGlobalStatus();
  const { cancelData, setCancelData } = useCancel();
  const { isLoading, setIsLoading, isProcessing, setIsProcessing } = useReportStatus();
  const { handleModifyReportApi } = useModifyReport(media);
  const reportData = useReportData(media);
  const {
    cidList,
    selectedAdAccounts,
    setSelectedAdAccounts,
    campaignList,
    setCampaignList,
    selectedCampaign,
    setSelectedCampaign,
    handleCampaignData,
    origiCustomData,
    setOrigiCustomData,
    handleCustomData,
    selectedOptionFields,
    setSelectedOptionFields,
    fetchData,
  } = reportData;

  const [currentTab, setCurrentTab] = useState(0);
  const [reportName, setReportName] = useState('');
  const [dateRange, setDateRange] = useState({ startSendDate: null, endSendDate: null });
  const [reportDateRange, setReportDateRange] = useState({ startReportDate: null, endReportDate: null });
  const [reportLanguage, setReportLanguage] = useState("CHINESE");
  const [sendTimeData, setSendTimeData] = useState(SEND_TIME_DATA);

  const [emailList, setEmailList] = useState([]);
  const [emailString, setEmailString] = useState();
  const [emailTemplateType, setEmailTemplateType] = useState(basicConstants.EMAIL_TEMPLATE_REACH);
  const [emailTemplatePrev, setEmailTemplatePrev] = useState({});
  const [emailTemplateCurrent, setEmailTemplateCurrent] = useState({});

  const [excelSheetSelected, setExcelSheetSelected] = useState([]);

  const [allOptionFields, setAllOptionFields] = useState([]);
  const [updateSortFields, setUpdateSortFields] = useState([]); //已選擇的所有欄位排序

  const [inputErrorMsg, setInputErrorMsg] = useState(INPUT_ERROR_MSG)
  const [downloadInputErrorMsg, setDownloadInputErrorMsg] = useState(DOWNLOAD_ERROR_MSG)

  const [anchorEl, setAnchorEl] = useState(null);
  const popOpen = Boolean(anchorEl);
  const [openModal, setOpenModal] = useState(false);
  const [downloadOrSend, setDownloadOrSend] = useState('');
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  const accountSettings = { cidList, selectedAdAccounts, setSelectedAdAccounts };
  const campaignSettings = { campaignList, setCampaignList, selectedCampaign, setSelectedCampaign };
  const fieldsSettings = {
    allOptionFields,
    setAllOptionFields,
    selectedOptionFields,
    setSelectedOptionFields,
    origiCustomData,
    setOrigiCustomData,
    updateSortFields,
    setUpdateSortFields
  }
  const emailSettints = {
    emailList,
    setEmailList,
    emailString,
    setEmailString,
    EmailTemplate,
    emailTemplateCurrent,
    setEmailTemplateCurrent,
    emailTemplatePrev,
    setEmailTemplatePrev,
    emailTemplateType,
    setEmailTemplateType
  }

  useEffect(() => {
    if (entryPath === '') {
      history.push(urlConstants.PAGE_MEDIA_MENU);
    }
  }, [entryPath])

  useEffect(() => {
    setCampaignList([]);
    setSelectedCampaign([]);
    setOrigiCustomData([]);

    const customFieldsIndex = selectedOptionFields.findIndex(el => el.cid !== null || el.type === "CUSTOM");
    if (!selectedAdAccounts.length && customFieldsIndex > -1) {
      const clearSelectCustomFields = selectedOptionFields.filter(el => !el.cid && el.type !== "CUSTOM");
      setSelectedOptionFields(clearSelectCustomFields);
    }

  }, [selectedAdAccounts])

  useEffect(() => {
    if (downloadOrSend === 'downloadData') {
      return;
    } else if (downloadOrSend === 'sendData') {
      handleStoreReport();
    }
  }, [downloadOrSend])

  //廣告活動(回傳格式)
  const campaignData = selectedCampaign.map((edition) => {
    return {
      cid: edition.cid,
      cidname: edition.cidname,
      id: edition.id,
      name: edition.name
    }
  })

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name === 'reportName') {
      setReportName(value);
    }
    if (name === 'emailString') {
      setEmailString(value);
    }
  }

  const handleModalDetail = (type) => {
    setOpenModal(true);

    if (type === 'create_custom_metric') {
      setModalName('create_custom_metric');
    }
  }

  //新增自定義指標
  const addCustomFields = (newFields, matchFields) => {
    const cloneAllOptionFields = JSON.parse(JSON.stringify(allOptionFields));
    const customFieldsIndex = _.findIndex(cloneAllOptionFields, (el) => el.category === 'custom');

    if (customFieldsIndex > -1) {
      cloneAllOptionFields[customFieldsIndex].child.push(newFields);
    } else {
      cloneAllOptionFields.unshift({
        category: 'custom',
        name: '自定義指標',
        child: [newFields]
      })
    }

    setAllOptionFields(cloneAllOptionFields);

    // 有設公式的指標自動打勾
    cloneAllOptionFields.forEach(field => {
      field.child.forEach(el => {
        if (matchFields.includes(el.expression)) {
          if (!selectedOptionFields.some(item => item.expression === el.expression)) {
            setSelectedOptionFields(prev => [...prev, el]);
          }
        }
      })
    })

    setSelectedOptionFields(prev => [...prev, newFields]);
  }

  const validateReportForm = (isDownload) => {
    const formData = {
      reportName,
      fbAdAccounts: selectedAdAccounts,
      excelSheet: excelSheetSelected,
      selectFields: selectedOptionFields,
      optionFieldName: selectedOptionFields,
      reportType: sendTimeData,
      emailList,
      emailTemplate: emailTemplateCurrent,
      emailTemplateType,
      dateRange,
      isDownload
    };

    return checkReportForm(formData, media);
  }

  const clickDownloadReport = () => {
    setDownloadOrSend('downloadData');
    const { errorMsg, isErrorStatue } = validateReportForm(true);
    setInputErrorMsg({ ...errorMsg, reportDateRange: '' });

    if (isErrorStatue) {
      if (errorMsg.reportName || errorMsg.fbAdAccounts) {
        scrollToAnchor('scrollTop');
      }
      return;
    }

    setModalName('setting_report_dateRange');
    setModalContent({ ...MODAL_CREATE_REPORT['chooseSaveReport'], media: media });
  }

  const clickUpdateReport = () => {
    if (downloadOrSend === 'downloadData' || downloadOrSend === '') {
      setDownloadOrSend('sendData');
    } else if (downloadOrSend === 'sendData') {
      handleStoreReport();
    }
  }

  const prepareReportData = () => {
    const formatDateIfNotNull = date => date !== null ? formatDate(date) : null;
    const updateSelectedFields = handleRelatedFields(selectedOptionFields, allOptionFields, excelSheetSelected);
    setSelectedOptionFields(updateSelectedFields);

    return {
      "weeklyReportName": reportName,
      "startSendDate": null,
      "endSendDate": null,
      "sendDay": sendTimeData.weekday + 1,
      "sendTime": basicConstants.HOUR_LIST[sendTimeData.weektime],
      "monthly": sendTimeData.monthday + 1,
      "biweekly_day": sendTimeData.biWeekDay + 1,
      "biweekly_start": sendTimeData.reportType.includes('2') ? handleBiweeklyStart(currentActiveData, sendTimeData) : null,
      "reportType": sendTimeData.reportType.join(','),
      "facebookAdAccountIds": selectedAdAccounts.map(el => el.adAccountId),
      "toAddresses": emailList.filter(el => el !== ""),
      "mailMessageType": emailTemplateType,
      "mailMessageExtra": null,
      "excelSheets": excelSheetSelected,
      "fields": updateSelectedFields,
      "startReportDate": formatDateIfNotNull(reportDateRange.startReportDate),
      "endReportDate": formatDateIfNotNull(reportDateRange.endReportDate),
      "campaignList": campaignData.map((el) => el.id)
    }
  }

  const handleChooseSaveReport = (saveSettings) => {
    const errorMsg = checkDateRangeForm(reportDateRange);
    setInputErrorMsg({ reportDateRange: errorMsg });
    if (errorMsg) return;

    const storeReportData = prepareReportData();

    if (saveSettings === 'saveReport') {
      handleDownloadReport(storeReportData);
    } else {
      setModalContent({ ...MODAL_CREATE_REPORT['processingDownloadReport'], media: media });
      setIsModalOpen(true);
      setModalName('');
      downloadExternalReport(storeReportData);
    }
  }

  const handleDownloadReport = (storeReportData) => {
    if (entryPath.includes("create")) {
      handleModifyReportApi("create", storeReportData, downloadOrSend, reportName);
    } else if (entryPath.includes("edit")) {
      handleModifyReportApi("edit", storeReportData, downloadOrSend, reportName);
    }
  }

  const handleStoreReport = () => {
    const { isTab1Error, isTab2Error, errorMsg, isErrorStatue } = validateReportForm(false);
    setInputErrorMsg(errorMsg);

    if (isTab1Error) {
      scrollToAnchor('scrollTop');
      setCurrentTab(0);
    } else if (isTab2Error) {
      scrollToAnchor('scrollTop');
      setCurrentTab(1);
    }

    if (isErrorStatue) return;

    const storeReportData = prepareReportData();

    if (entryPath.includes("create")) {
      handleModifyReportApi("create", storeReportData, downloadOrSend, reportName);
    } else if (entryPath.includes("edit")) {
      handleModifyReportApi("edit", storeReportData, downloadOrSend, reportName);
    }
  }

  const downloadReport = () => {
    setIsProcessing('downloadReport');
    const updatedReportName = checkExcelNaming(reportName);
    const dataRange = handleDateRange(reportDateRange.startReportDate, reportDateRange.endReportDate);
    const fileName = `【Taboola報表】${updatedReportName}_${dataRange}.xlsx`;

    apiList.downloadTaboolaReport({
      weeklyReportId: currentActiveData.weeklyReportId,
      start_date: formatDate2(reportDateRange.startReportDate),
      end_date: formatDate2(reportDateRange.endReportDate)
    })
      .then(res => {
        if (res.status === 201) {
          const contentType = res.headers['content-type'];
          const file = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          setTimeout(() => {
            setIsModalOpen(false);
            setIsProcessing(false);
            history.push(urlConstants.PAGE_TABOOLA_SEND_LIST)
          }, 2000)
        } else if (res.status === 401) {
          setIsModalOpen(false);
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else if (res.status === 404) {
          setIsProcessing(false);
          setModalContent({ ...MODAL_CREATE_REPORT['downloadReportNoData'], media: media });
          setIsModalOpen(true);
        } else {
          setIsModalOpen(false);
          setIsProcessing(false);
          handleAlertMsgSettings(true, { type: alertConstants.ALERT_TYPE.ERROR, msg: `${alertConstants.ERROR_SYSTEMCONNECT} ${res.status}` });
          history.push(urlConstants.PAGE_TABOOLA_SEND_LIST)
        }
      })
  }

  const downloadExternalReport = (updateReportData) => {
    setIsProcessing('downloadReport');
    const updatedReportName = checkExcelNaming(reportName);
    const dataRange = handleDateRange(reportDateRange.startReportDate, reportDateRange.endReportDate);
    const fileName = `【Taboola報表】${updatedReportName}_${dataRange}.xlsx`;

    const params = {
      requestKey: requestKey,
      startDate: formatDate3(reportDateRange.startReportDate),
      endDate: formatDate3(reportDateRange.endReportDate)
    }

    apiList.downloadTaboolaExternalReport({ data: updateReportData, config: params })
      .then(res => {
        if (res.status === 201) {
          const contentType = res.headers['content-type'];
          const file = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          setIsModalOpen(false);
          setTimeout(() => {
            setIsProcessing(false);
            history.push(urlConstants.PAGE_TABOOLA_SEND_LIST)
          }, 2000)
        } else if (res.status === 401) {
          setIsModalOpen(false);
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else if (res.status === 404) {
          setIsProcessing(false);
          setModalContent({ ...MODAL_CREATE_REPORT['downloadReportNoData'], media: media });
          setIsModalOpen(true);
        } else {
          setIsModalOpen(false);
          setIsProcessing(false);
          handleAlertMsgSettings(true, { type: alertConstants.ALERT_TYPE.ERROR, msg: `${alertConstants.ERROR_SYSTEMCONNECT} ${res.status}` });
          history.push(urlConstants.PAGE_TABOOLA_SEND_LIST)
        }
      })
  }

  const handleModalSubmit = (data, type) => {
    switch (type) {
      case 'confirm_download_report':
        downloadReport();
        break;
      case 'download_report_no_data':
        setIsModalOpen(false);
        if (entryPath === urlConstants.PAGE_TABOOLA_CREATE_DATA) {
          setEntryPath(urlConstants.PAGE_TABOOLA_EDIT_DATA);
        }
        break;
      case 'check_import_customfields':
      case 'check_no_customfields':
      case 'check_import_campaign':
      case 'check_no_campaign':
      case 'check_no_running_or_paused_campaign':
        setIsModalOpen(false);
        break;
      default:
        break;
    }
  }

  // console.log('selectedOptionFields', selectedOptionFields);

  return (
    <>
      {userData.scopes.includes(basicConstants.AUTH_EDIT_REPORT) &&
        <>
          <Box
            id="scrollTop"
            sx={{
              width: { sm: '100%', md: '80%', lg: '70%' },
              margin: '0 auto 60px'
            }}
          >
            {cidList.length > 0 &&
              <>
                <FormTitle
                  media={mediaDisplayName}
                  currentTab={currentTab}
                  mainColor={mainColor}
                  setCurrentTab={setCurrentTab}
                />

                <Box sx={{ overflow: 'hidden' }}>
                  <Box
                    sx={{
                      position: 'relative',
                      top: 0,
                      left: `-${currentTab * 100}%`,
                      display: 'flex',
                      justifyContent: 'flex-start',
                      width: '200%',
                      transition: 'left .5s'
                    }}
                  >
                    <Box id="basicData" sx={{ width: '100%', padding: '0 4px' }}>
                      <NameAndAccountData
                        {...accountSettings}
                        media={mediaDisplayName}
                        reportName={reportName}
                        setReportName={setReportName}
                        handleInput={handleInput}
                        inputErrorMsg={inputErrorMsg}
                      />

                      <TaboolaCampaignData
                        {...campaignSettings}
                        selectedAdAccounts={selectedAdAccounts}
                        handleCampaignData={handleCampaignData}
                        fetchData={fetchData}
                        setModalName={setModalName}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        scrollToAnchor={scrollToAnchor}
                      />

                      <ExcelData
                        media={media}
                        excelSheets={excelSheets}
                        excelSheetSelected={excelSheetSelected}
                        setExcelSheetSelected={setExcelSheetSelected}
                        setSelectedOptionFields={setSelectedOptionFields}
                        inputErrorMsg={inputErrorMsg}
                        downloadInputErrorMsg={downloadInputErrorMsg}
                      />

                      <TaboolaFieldsData
                        {...fieldsSettings}
                        selectedAdAccounts={selectedAdAccounts}
                        excelSheetSelected={excelSheetSelected}
                        handleModalDetail={handleModalDetail}
                        handleCustomData={handleCustomData}
                        fetchData={fetchData}
                        inputErrorMsg={inputErrorMsg}
                        downloadInputErrorMsg={downloadInputErrorMsg}
                        setModalName={setModalName}
                        scrollToAnchor={scrollToAnchor}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                      />

                      <ButtonReportData
                        id="scrollDown"
                        colorSystem={colorMedia}
                        clickDownloadReport={clickDownloadReport}
                        setCurrentTab={setCurrentTab}
                        scrollToAnchor={scrollToAnchor}
                      />

                    </Box>

                    <Box id="pagesAndFields" sx={{ width: '100%', padding: '0 4px' }}>
                      <SendTime
                        media={media}
                        sendTimeData={sendTimeData}
                        setSendTimeData={setSendTimeData}
                        inputErrorMsg={inputErrorMsg}
                      />

                      <EmailData
                        {...emailSettints}
                        media={media}
                        inputErrorMsg={inputErrorMsg}
                        setInputErrorMsg={setInputErrorMsg}
                        handleInput={handleInput}
                      />

                      <ButtonSendData
                        colorSystem={colorMedia}
                        setCurrentTab={setCurrentTab}
                        clickUpdateReport={clickUpdateReport}
                        url={urlConstants.PAGE_TABOOLA_SEND_LIST}
                      />

                    </Box>

                  </Box>
                </Box>
              </>
            }
          </Box>
          {cidList.length === 0 && !isLoading &&
            <NoAdAccountPage
              colorSystem={colorMedia}
              setEntryPath={setEntryPath}
            />
          }
          {modalName === 'alert' &&
            <Modal open={modalName === 'alert'}>
              <BoxModalAlert>
                已儲存 <span style={{ color: mainColor }}>{reportName}</span> 寄送通知<br />
              </BoxModalAlert>
            </Modal>
          }
          {modalName === 'create_custom_metric' &&
            <CreateFields
              media={media}
              optionalFields={allOptionFields}
              open={modalName === 'create_custom_metric'}
              handleClose={() => setModalName(false)}
              handleSave={addCustomFields}
              reportLanguage={reportLanguage}
              excelSheetSelected={excelSheetSelected}
            />
          }
          {/* 自訂走期下載報表 */}
          {modalName === 'setting_report_dateRange' &&
            <DownloadReportModal
              media={media}
              open={modalName === 'setting_report_dateRange'}
              reportDateRange={reportDateRange}
              setReportDateRange={setReportDateRange}
              inputErrorMsg={inputErrorMsg}
              isLoading={isProcessing}
              handleClose={() => setModalName(false)}
              handleChooseSaveReport={handleChooseSaveReport}
            />
          }
          <ModalComponent
            isLoading={isProcessing}
            handleModalSubmit={handleModalSubmit}
          />
        </>
      }
      <Loading isLoading={isLoading} content={alertConstants.TIP_DATA_LOADING} />

      <AlertMsg />
    </>
  )
}

export default TaboolaCreateData;